import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ui-input-addon',
    styleUrls: ['./input-addon.component.scss'],
    template: `
        <ng-content></ng-content>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class InputAddonComponent {
	@HostBinding('class.input-group-addon') addon = true;
	@Input() disabled: boolean;

	@HostBinding('attr.disabled')
	public get isDisabled(): string | null {
		return this.disabled ? "disabled" : null;
	}
}
